import Filter from "./Filter";
import FormData from "./FormData";
import MenuTabs from "./MenuTabs";
import ListData from "./ListData";
import TableData from "./TableData";
import Review from "./Review";

const membersComponents = {
  Filter,
  FormData,
  MenuTabs,
  ListData,
  TableData,
  Review
}

export default membersComponents